import { Link } from "react-router-dom";

const DOMAINS = [
    { label: "Total Facility Management", slug: "facility-management" },
    { label: "Waste Recovery Solutions", slug: "waste-recovery" },
    { label: "Alva Oliva — Extra Virgin Olive Oil", slug: "alva-oliva" },
    { label: "UCO Sourcing & Supply", slug: "uco-sourcing" },
    { label: "Advanced Materials", slug: "advanced-materials" },
    { label: "IT & System Integration Solutions", slug: "it-system-integration" },
];

export const Footer = () => (
    <footer
        data-testid="footer"
        className="relative border-t border-[#DCE5D4] bg-[#F1F5EE]"
    >
        <div className="mx-auto max-w-[1440px] px-6 py-16 md:px-10 md:py-20">
            <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
                <div>
                    <img
                        src="/assets/nomas-logo-light.png"
                        alt="NOMAS"
                        className="h-9 w-auto"
                        data-testid="footer-logo"
                    />
                    <p className="font-display mt-6 text-sm font-light tracking-[0.35em] text-[#598B3B] uppercase">
                        Sustain. Innovate. Grow.
                    </p>
                    <p className="mt-4 max-w-xs text-xs leading-relaxed text-[#7A8C80]">
                        Environment &middot; Trading &middot; Technology &middot;
                        Consultancy — one integrated system.
                    </p>
                </div>

                <div>
                    <p className="mb-6 text-[11px] uppercase tracking-[0.3em] text-[#7A8C80]">
                        Solutions
                    </p>
                    <ul className="flex flex-col gap-3">
                        {DOMAINS.map((d, i) => (
                            <li key={d.slug}>
                                <Link
                                    to={`/solutions/${d.slug}`}
                                    data-testid={`footer-solution-${i + 1}`}
                                    className="text-left text-sm text-[#45543F] transition-colors duration-300 hover:text-[#0E1112]"
                                >
                                    {d.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="mb-6 text-[11px] uppercase tracking-[0.3em] text-[#7A8C80]">
                        Contact
                    </p>
                    <ul className="flex flex-col gap-3 text-sm text-[#45543F]">
                        <li>UAE</li>
                        <li>
                            <a
                                href="tel:+971563141428"
                                data-testid="footer-phone"
                                className="transition-colors duration-300 hover:text-[#0E1112]"
                            >
                                +971 56 314 1428
                            </a>
                        </li>
                        <li>
                            <a
                                href="mailto:gm@nomas-co.com"
                                data-testid="footer-email"
                                className="transition-colors duration-300 hover:text-[#0E1112]"
                            >
                                gm@nomas-co.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-[#DCE5D4] pt-8">
                <p className="text-xs text-[#7A8C80]" data-testid="footer-copyright">
                    &copy; 2026 NOMAS. All rights reserved.
                </p>
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#8CA093]">
                    Leading Solution Integrator &middot; UAE
                </p>
            </div>
        </div>
    </footer>
);
